// AsyncTaskStatusState corresponds to `state` in `celery.result`
export type AsyncTaskStatusState =
  | 'PENDING'
  | 'RECEIVED'
  | 'STARTED'
  | 'SUCCESS'
  | 'FAILURE'
  | 'RETRY'
  | 'REVOKED';

export type AsyncTaskStatusQueryKey = readonly [
  'common',
  'asyncTaskStatuses',
  UseAsyncTaskStatusParams,
];

export type UseAsyncTaskStatusParams = {
  taskIds: string[];
  groupId: string;
  onFinishTasks: (result: {
    successes: AsynTaskStatusSuccessfulResponseData[];
    failures: AsynTaskStatusFailureResponseData[];
  }) => void;
  customRefetchInterval?: number;
};

export type AsyncTaskStatusResponseContext = Record<
  'quoteItemId' | 'exception' | string,
  string
>;

export type AsyncTaskStatusResponseData = {
  taskId: string;
  taskStatus: AsyncTaskStatusState;
  context: AsyncTaskStatusResponseContext;
};

export type AsynTaskStatusSuccessfulResponseData =
  AsyncTaskStatusResponseData & {
    taskStatus: 'SUCCESS';
  };
export type AsynTaskStatusFailureResponseData = AsyncTaskStatusResponseData & {
  taskStatus: 'FAILURE';
};

export type AsyncTaskStatusesResponseData = {
  taskStatuses: AsyncTaskStatusResponseData[];
};

export const isAsyncTaskSuccess = (
  asyncTaskResponse: AsyncTaskStatusResponseData,
): asyncTaskResponse is AsynTaskStatusSuccessfulResponseData =>
  asyncTaskResponse.taskStatus === 'SUCCESS';

export const isAsyncTaskFailure = (
  asyncTaskResponse: AsyncTaskStatusResponseData,
): asyncTaskResponse is AsynTaskStatusFailureResponseData =>
  asyncTaskResponse.taskStatus === 'FAILURE';
